/**
 * Component to handle profile bulk upload
 */
import * as React from 'react';
import { Table, Card, Button, Row, Col, message, Select } from 'antd';
import '../../../css/ProfileBulkUpload.scss';
import Utils from '../../common/utils';
import strings from '../../../eyeguide-localization/profile/strings.profile.bulkupload';
import dataservice from '../../../service/data.service';
import DuplicateProfileFilter from './DuplicateProfileFilter';
import { CustomSorter } from '../../Sorter';

const ERRORMSG = 'Invalid';
const NODATAMSG = 'Not Specified';
const INVALIDDATEFORMATMSG = 'Invalid Date Format';
const INVALIDGENDERMSG = 'Not Acceptable Gender Value';
const INVALIDEMAILMSG = 'Invalid Email Format';
const INVALIDPHONEMSG = 'Invalid Phone Format';
const INVALIDSPORTMSG = 'Invalid Sport';
const INVALIDLEVELMSG = 'Invalid Level';

const REQUIREDKEYS = [
    'index',
    'firstname', 
    'lastname', 
    'dob',
    'gender',
    'email',
    'phone'
];

const UNIQUEKEYS = [    
    'firstname', 
    'lastname', 
    'dob'
];

const DUPLICATEMSG = 'Following duplicate profiles found in CSV file, please remove ambiguity to process.';

interface IUploadProfileContentFourProps {
    rosterName: any;
    rosterid: any;
    columnData: any;
    currentProfiles: Array<any>;
    columnHeaders: Array<any>; 
    hasHeader: boolean;
    csvRows: Array<any>;
    loading: boolean;
    handleNextClick: any;
    handlePrevClick: any;
    validateGender: any;
    validateEmail: any;
    validatePhone: any;
    validateSport: any;
    validateLevel: any;
    getDob: any;
    FirstNameCol: string;    
    LastNameCol: string;    
    DOBCol: string;
    GenderCol: string;
    SportCol: string;
    LevelCol: string;
    EmailCol: string;
    PhoneCol: string;
}

interface IUploadProfileContentFourState {
    columns: Array<any>;
    columnData: Array<any>;
    selectedUniqueRows: Array<any>;
    isError: boolean;
    pagination: any; 
    loading: boolean;
    current: number;
    uploadStatus: number;
    disableUpload: boolean;
    errorMessage: string;
    profiles: Array<any>;
    duplicateProfiles: Array<any>;
    hasDuplicate: boolean;
    FirstNameCol: string;    
    LastNameCol: string;    
    DOBCol: string;
    GenderCol: string;
    SportCol: string;
    LevelCol: string;
    EmailCol: string;
    PhoneCol: string;
}

export default class UploadContentFour extends React.Component<IUploadProfileContentFourProps
    , IUploadProfileContentFourState> {

    constructor(props: IUploadProfileContentFourProps) {
        super(props);
        this.state = {
            columns: [],
            columnData: [],
            selectedUniqueRows: [],
            isError: false,
            pagination: {},            
            loading: this.props.loading,            
            current: 4,            
            uploadStatus: -1,
            disableUpload: false,
            errorMessage: strings.lsUploadErrorTxt,
            profiles: [],
            duplicateProfiles: [],
            hasDuplicate: false,
            FirstNameCol: this.props.FirstNameCol,   
            LastNameCol: this.props.LastNameCol, 
            DOBCol: this.props.DOBCol,
            GenderCol: this.props.GenderCol,
            SportCol: this.props.SportCol,
            LevelCol: this.props.LevelCol,
            EmailCol: this.props.EmailCol,
            PhoneCol: this.props.PhoneCol,
        };

        this.notifySelectedRow = this.notifySelectedRow.bind(this);
        this.handleDuplicateNext = this.handleDuplicateNext.bind(this);
        this.getVerifiedRowKey = this.getVerifiedRowKey.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    componentDidMount() {
        Utils.resetScroll();
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: any) {

        this.setState({loading: true});
        console.log('componentWillReceiveProps: ', nextProps);
        let errorRows = this.validateData(nextProps.columnData);
        
        let dupProfiles: any = [];
        if (errorRows.length === 0) {
            dupProfiles = this.checkDuplicateProfiles(nextProps.columnData);
        }

        console.log('errorRows', errorRows);        
        const pagination = { ...this.state.pagination };
        pagination.total = errorRows.length > 0 ? errorRows.length : 
            dupProfiles != null && dupProfiles.length ? dupProfiles.length : nextProps.columnData.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return `Total ${total} profiles`;
        };                   

        this.setState({
            loading: false,
            columns: this.buildColumns(dupProfiles !== null && dupProfiles.length > 0 ? true : false),
            columnData: errorRows.length > 0 ? errorRows : nextProps.columnData,
            isError: errorRows.length > 0 ? true : false,
            pagination,
            hasDuplicate: dupProfiles !== null && dupProfiles.length > 0 ? true : false, 
            duplicateProfiles: dupProfiles,            
        });

        console.log('step4 state: ', this.state);
    }

    /**
     * Render function called when row is expanded. Returns the HTML elements to display
     */
    _expandRowRender = (record: any, expanded: any, expandedRowKeys: any) => {
         
        let matchedProfiles: any = [];        
        if (expandedRowKeys <= this.state.duplicateProfiles.length) { 
            let row = this.state.duplicateProfiles.find(obj => { return obj.index === record.index; });            
            matchedProfiles = this.getAllMatchedProfiles(row);
            if (this.state.selectedUniqueRows.filter(obj => { 
                return obj.index === record.index; }).length === 0) { 
                
                let findIndex = this.state.selectedUniqueRows.map(obj => { return obj.index; }).indexOf(record.index);
                if (this.state.selectedUniqueRows.length > 0 && findIndex !== -1) {
                    this.state.selectedUniqueRows.map(obj => { 
                        if (obj.selectIndex === record.index) {
                            obj.index =  record.index;
                            obj.selectIndex = record.index;
                        } 
                    });
                } else {                    
                    this.state.selectedUniqueRows.push({index: record.index, selectIndex: -1});                    
                }
            } 
            console.log('_expandRowRender2: ', this.state.selectedUniqueRows);
        }
        
        return(
            <DuplicateProfileFilter 
                dupProfiles={matchedProfiles} 
                loading={this.state.loading}
                rowIndex={record.index}
                notifySelectedRow={this.notifySelectedRow}
                isRowVerified={this.getVerifiedRowKey(record.index)}
            />
        );
    }

    render() {
        return(
            <div className="UploadProfileContentFour"> 
                
                <Card bordered={false} style={{ margin: '24px 16px' }}> 
                   
                    {
                        this.state.isError ? 
                        <div> 
                            {this.state.errorMessage} 
                            <Table   
                                className="dataTable"              
                                columns={this.state.columns} 
                                dataSource={this.state.columnData} 
                                loading={this.state.loading}
                                rowClassName={(record, index) => 'rows'}
                                pagination={this.state.pagination}
                                rowKey={record => record.index}
                                bordered={true}
                                onHeaderRow={(column, index) => {
                                    return {
                                      onClick: () => { console.log('column', column); },        // click header row
                                    };
                                  }}
                                scroll={{ x: 1500 }}
                            />         
                            <Row>
                                <Col span={10} style={{padding: '10px', width: '55%'}}>
                                    <div className="buttonRight"> 
                                        <Button 
                                                onClick={e => this.props.handlePrevClick(3)}
                                                type="danger" 
                                        > 
                                        {'Previous'} 
                                        </Button> 
                                    </div>
                                </Col>
                            </Row>   
                        </div>
                        :
                        this.state.hasDuplicate ?
                        <div>         
                            {DUPLICATEMSG}                
                            <Table   
                                className="dataTable"              
                                columns={this.state.columns} 
                                dataSource={this.state.duplicateProfiles} 
                                loading={this.state.loading}
                                expandedRowRender={this._expandRowRender}                                
                                rowClassName={(record, index) => 'rows'}
                                pagination={this.state.pagination}
                                rowKey={record => record.index}
                                bordered={true}
                            />
                            <Row>
                                <Col span={10} style={{padding: '10px', width: '48%'}}>
                                    <div className="buttonRight"> 
                                        <Button 
                                                onClick={e => this.props.handlePrevClick(3)}
                                                type="danger"
                                                style={{width: '100%'}}
                                        > 
                                        {'Previous'} 
                                        </Button>
                                    </div>
                                </Col>
                                <Col span={10} style={{padding: '10px'}}>
                                    <div className="buttonLeft"> 
                                        <Button 
                                                onClick={e => this.handleDuplicateNext()}
                                                type="primary" 
                                                style={{width: '100%'}}
                                        > 
                                        {'Next'} 
                                        </Button> 
                                    </div>
                                </Col>
                            </Row> 
                        </div>
                        :
                        <div>
                            <Row>
                                <Button 
                                    icon="upload"
                                    className="downloadBtn"
                                    type="primary"
                                    disabled={this.state.disableUpload} 
                                    onClick={e => {this.uploadProfiles(); }}                                  
                                > 
                                    {strings.lsUploadTxt}
                                </Button>
                            </Row>
                            <div>
                                <Row>
                                    <Table   
                                        className="dataTable"              
                                        columns={this.state.columns} 
                                        dataSource={this.state.columnData} 
                                        loading={this.state.loading}
                                        rowClassName={(record, index) => 'rows'}
                                        pagination={this.state.pagination}
                                        rowKey={record => record.index}
                                        bordered={true}
                                        scroll={{ x: 1500 }}
                                    />
                                </Row>

                                <Row>
                                    <Col span={10} style={{padding: '10px', width: '55%'}}>
                                        <div className="buttonRight"> 
                                            <Button 
                                                    onClick={e => this.props.handlePrevClick(3)}
                                                    type="danger"
                                                    disabled={this.state.disableUpload}
                                            > 
                                            {'Previous'} 
                                            </Button> 
                                        </div>
                                    </Col>
                                </Row>  
                            </div>   
                        </div>
                    }                    
                </Card>
            </div>
        );
    }
    
    private handleDuplicateNext() {
        console.log('handleDuplicateNext: ', this.state.selectedUniqueRows);

        let notSelectedRows =  this.state.selectedUniqueRows.filter(obj => { return obj.selectIndex === -1; }).length;
        if ((this.state.selectedUniqueRows.length !== this.state.duplicateProfiles.length) || notSelectedRows > 0) {
            message.error('Please remove all ambiguities to proceed.');
            return null;
        }

        let rowsToRemove: any = [];
        this.state.selectedUniqueRows.forEach(row => {

            if (row.selectIndex !== -1) {
                let matchedrows = this.getAllMatchedProfiles(
                    this.state.columnData.find(obj => { return obj.index === row.index; }));

                matchedrows.forEach( matchedrow => { 
                    if (matchedrow.index !== row.selectIndex) {
                        rowsToRemove.push(matchedrow.index);
                    }
                });
            }
        });

        if (rowsToRemove.length > 0) {

            rowsToRemove.forEach(index => {
                let removeIndex = this.state.columnData.map(obj => {return obj.index; }).indexOf(index);
                this.state.columnData.splice(removeIndex, 1);
            });

            let dups = this.checkDuplicateProfiles(this.state.columnData);
            console.log('checkDuplicateProfiles.dups: ', dups);

            if (dups.length > 0) {
                message.error('Please remove all ambiguities to proceed.');
                return null;
            }

            const pagination = { ...this.state.pagination };
            pagination.total = this.state.columnData.length;
            pagination.pageSize = 20 ;
            pagination.pageSizeOptions = ['20', '50', '75', '100'];
            pagination.showSizeChanger = true ;  
            pagination.showTotal = function (total: any) {
                return `Total ${total} profiles`;
            };     

            let colIndx = this.state.columns.map(ele => { return ele.dataIndex; }).indexOf('status');            
            this.state.columns.splice(colIndx, 1);
            this.state.columns[0].fixed = 'left';
            this.state.columns[0].width =  100;
            this.addColumns(this.state.columns);
            
            this.setState({
                hasDuplicate: false,
                duplicateProfiles: [],
                columns: this.state.columns,
                pagination
            });

            console.log('checkDuplicateProfiles.hasDuplicate: ', this.state.hasDuplicate);
        } else {
            message.error('Please remove all ambiguities to proceed.');
            return null;
        }

        return this.state.columnData;
    }

    private notifySelectedRow(notifiedRow: any) {  
        this.state.selectedUniqueRows.map(obj => { 
            obj.selectIndex = obj.index === notifiedRow.parentKey 
                ? notifiedRow.selectedKey : obj.selectIndex; });
        
        let selectedRow = this.state.columnData.filter(obj => { 
            return obj.index === notifiedRow.selectedKey; });
        selectedRow.map(ele => { ele.status = 'verified'; });
        console.log('selectedRow: ', selectedRow);

        let rowIndex = this.state.duplicateProfiles.map(obj => { 
            return obj.index; }).indexOf(notifiedRow.parentKey);
        this.state.duplicateProfiles.splice(rowIndex, 1, selectedRow[0]);
        let dups = this.state.duplicateProfiles;
        
        this.state.selectedUniqueRows.map(obj => { 
            obj.index = obj.selectIndex === notifiedRow.selectedKey 
                ? obj.selectIndex : obj.index; });

        this.setState({duplicateProfiles: dups, columns: this.buildColumns(true)});
        console.log('notifySelectedRow: ', this.state.selectedUniqueRows);
    }

    /**
     * Validates the data retrived from uploaded csv file
     * @param data CSV Data to be validated
     */
    private validateData(data: any) {
        let errorRows: any = [];
        errorRows = data.filter((e: any) => { // get the error rows
            let isError: boolean = false;

            let hasPhone = e.phone !== undefined && e.phone !== '';
            let hasEmail = e.email !== undefined && e.email !== '';
            if (!hasEmail && !hasPhone) {
                e.email = e.phone = NODATAMSG;
                isError = true;
            }
            if (e.sport.toString().trim() === INVALIDSPORTMSG
                || e.level.toString().trim() === INVALIDLEVELMSG) {
                isError = true;
            }

            for (let key of Object.keys(e)) {
                if ( REQUIREDKEYS.indexOf(key) > -1 ) {
                    if (e[key]  === undefined || e[key]  === null ) {
                        isError = true;
                        e[key] = ERRORMSG;
                    } else if (e[key] !== undefined && e[key]  !== null && e[key].toString().trim() === '') {
                        if (!((key.toLowerCase() === 'phone' || key.toLowerCase() === 'email') 
                            && e[key].toString().trim() === '')) {
                            isError = true;
                            e[key] = NODATAMSG;
                        }
                    } else if (e[key].toString().trim() === ERRORMSG) {
                        isError = true;
                        e[key] = ERRORMSG;
                    } else if (e[key].toString().trim() === NODATAMSG) {
                        isError = true;
                        e[key] = NODATAMSG;
                    } else if (e[key].toString().trim() === INVALIDDATEFORMATMSG) {
                        isError = true;
                        e[key] = INVALIDDATEFORMATMSG;
                    } else if (e[key].toString().trim() === INVALIDGENDERMSG) {
                        isError = true;
                        e[key] = INVALIDGENDERMSG;
                    } else if (e[key].toString().trim() === INVALIDEMAILMSG) {
                        isError = true;
                        e[key] = INVALIDEMAILMSG;
                    } else if (e[key].toString().trim() === INVALIDPHONEMSG) {
                        isError = true;
                        e[key] = INVALIDPHONEMSG;
                    }
                }
            }
            return isError;
        });

        return errorRows;
    }

    /**
     * check any duplicate profiles in data retrived from uploaded csv file
     * @param data CSV Data to be validated
     */
    private checkDuplicateProfiles(data: any) {

        let rowKeys: Array<any> = [];
        let dups: Array<any> = [];
        data.forEach((e: any) => { // get the duplicate rows
            
            let rowKey = this.getUniqueRowKey(e);
            let newrow: Array<any> = [];
            newrow.push(e);
            rowKeys.push({key: rowKey, row: e});
            
            let matchedrows = rowKeys.filter( object => { 
                return object.key === rowKey; });
            if (matchedrows.length > 1) {
                let alreadyExist = dups.filter(row => { return rowKey === this.getUniqueRowKey(row); }).length > 0;
                if ( alreadyExist === false) {
                    dups.push(matchedrows.map(obj => { return obj.row; })[0]);
                }
            }
        });

        console.log('checkDuplicateProfiles: ', dups);
        return dups;
    }

    private getAllMatchedProfiles(row: any) {

        let matchKey = this.getUniqueRowKey(row);
        return this.state.columnData.filter((e: any) => {
            let rowKey = this.getUniqueRowKey(e);            
            return matchKey === rowKey;            
        });
    }

    private getUniqueRowKey(row: any) {
        let rowKey = '';
        for (let key of Object.keys(row)) {
            if ( UNIQUEKEYS.indexOf(key) > -1 ) {
                                    
                if ( row[key] !== undefined && row[key]  !== null 
                    && row[key].toString().trim() !== 'Invalid' && key.toString() !== 'index') {

                    rowKey += row[key] !== null && row[key].length > 0 
                                ? row[key].toString().trim() : '';                                                
                }
            }
        }

        return rowKey;
    }    

    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(hasDuplicates: boolean = false) {        
        let columns: any = [
        { 
            title:  'Row #',
            dataIndex: 'index',
            sorter: this.state.isError ? undefined : (a: any, b: any) => 
            parseInt(a.index, 10) < parseInt(b.index, 10) ? -1 : 1,
            className: 'rows',
            onHeaderCell: (column) => {
                console.log('onHeaderCell' , column);
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
        },
          
        {
            title:  this.hasError('firstname') ?
            (   
                <div> 
                    <Select 
                        className="fill"
                        placeholder="Select Column"
                        value={this.state.FirstNameCol}
                        onChange={e => { 
                            this.handleOnChange('firstname', e); 
                            console.log('build column firstname: ', this.state.FirstNameCol);
                        }}    
                    >
                    {
                        this.props.columnHeaders.map((item, i) =>  
                            <option id={item.index} value={item.index} key={item.index}> 
                                {item.name} 
                            </option> )
                    }
                    </Select>
                </div>
            ) : 'First Name',
            dataIndex: 'firstname',
            sorter: this.hasError('firstname') ? undefined : (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',            
            render: (text: any) => 
                text === ERRORMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>
                ) : (text === NODATAMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (
                <div className="clipped" title={text}>
                    {text}
                </div>)),
            ellipsis: true,
            onHeaderCell: (column) => {
                return column.sorter !== undefined ?
                {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                } : null;
            }
        },
        {            
            title: 'Middle Name',
            dataIndex: 'middlename',
            sorter: (a: any, b: any) => a.middlename.localeCompare(b.middlename),
            className: 'rows',
            render: (text: any) => 
                text === ERRORMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (
                <div className="clipped" title={text}>
                    {text}
                </div>),
            onHeaderCell: (column) => {
                return column.sorter !== undefined ?
                {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                } : null;
            }
        },
        {
            title:  this.hasError('lastname') ?
            (   
                <div> 
                    <Select 
                        className="fill"
                        placeholder="Select Column"
                        value={this.state.LastNameCol}
                        onChange={e => { 
                            this.handleOnChange('lastname', e);
                            console.log('build column lastname: ', this.state.LastNameCol);
                        }}
                    >
                    {
                        this.props.columnHeaders.map((item, i) =>  
                            <option id={item.index} value={item.index} key={item.index}> 
                                {item.name} 
                            </option> )
                    }
                    </Select>
                </div>
            ) : 'Last Name',
            dataIndex: 'lastname',
            sorter: this.hasError('lastname') ? undefined : (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : (text === NODATAMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (
                <div className="clipped" title={text}>
                    {text}
                </div>)),
            onHeaderCell: (column) => {
                return column.sorter !== undefined ?
                {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                } : null;
            }
        },
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: (a: any, b: any) => a.id.localeCompare(b.id),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : (
            <div className="clipped" title={text}>
                {text}
            </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
        } ,
        {
            title:  this.hasError('dob') ?
            (   
                <div> 
                    <Select 
                        className="fill"
                        placeholder="Select Column"
                        value={this.state.DOBCol}
                        onChange={e => { 
                            this.handleOnChange('dob', e); 
                            console.log('build column dob: ', this.state.DOBCol);
                        }}
                    >
                    {
                        this.props.columnHeaders.map((item, i) =>  
                            <option id={item.index} value={item.index} key={item.index}> 
                                {item.name} 
                            </option> )
                    }
                    </Select>
                </div>
            ) : 'Date of Birth',
            dataIndex: 'dob',
            sorter: this.hasError('dob') ? undefined : (a: any, b: any) => Utils.dataDiff(a.dob, b.dob),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : (text === NODATAMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (text === INVALIDDATEFORMATMSG ? (
                
                <div
                    className="clipped"
                    title={strings.lsDOBErrorTxt}
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (
                <div className="clipped" title={text}>
                    {text}
                </div>))),
            onHeaderCell: (column) => {
                return column.sorter !== undefined ?
                {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                } : null;
            }
        } ,
        {   
            title:  this.hasError('gender') ?
            (   
                <div> 
                    <Select 
                        className="fill"
                        placeholder="Select Column"
                        value={this.state.GenderCol}
                        onChange={e => { 
                            this.handleOnChange('gender', e);
                            console.log('build column gender: ', this.state.GenderCol);
                        }}
                    >
                    {
                        this.props.columnHeaders.map((item, i) =>  
                            <option id={item.index} value={item.index} key={item.index}> 
                                {item.name} 
                            </option> )
                    }
                    </Select>
                </div>
            ) : 'Gender',
            dataIndex: 'gender',
            sorter: this.hasError('gender') ? undefined : (a: any, b: any) => {
                let agender = a.gender !== null ? a.gender : '';
                let bgender = b.gender !== null ? b.gender : '';
                return agender <= bgender ? -1 : 1;
                },
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : (text === NODATAMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : (text === INVALIDGENDERMSG ? (
                
                <div
                    className="clipped"
                    title={INVALIDGENDERMSG}
                    style={{color: 'red'}}
                >
                {text}
                </div>) : text)) ,
            onHeaderCell: (column) => {
                return column.sorter !== undefined ?
                {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });                        
                    } 
                } : null;
            }
        }];
        /**
         * These columns are not included in identifying duplicates so not showing these
         * on duplicates page
         */
        if (!(this.state.hasDuplicate === true || hasDuplicates === true)) {
            columns[0].fixed = 'left';
            columns[0].width =  100;
            this.addColumns(columns);
        } 
          
        if (this.state.hasDuplicate === true || hasDuplicates === true) {
              
            columns.push({
                title: 'Status',
                dataIndex: 'status',
                sorter: (a: any, b: any) =>  {
                    let astatus = a.status !== null && a.status !== undefined ? a.status : 'unverified';
                    let bstatus = b.status !== null && b.status !== undefined ? b.status : 'unverified';
                    if (astatus < bstatus) {
                        return -1;
                    }
                    
                    if (astatus > bstatus) {
                        return 1;
                    }

                    return 0;
                },
                className: 'rows',
                render: (text: any) => 
                text === 'verified' ? (
                
                <div
                    style={{color: 'green'}}
                >
                    {text}
                </div>) : ( 
                <div
                    style={{color: 'red'}}
                >
                    {'unverified'}
                </div>
                ) ,
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            });
        }

        return columns;
    }

    /**
     * To add extra columns to table when necessary
     */
    private addColumns(columns: any) {
        columns.push(
            {   
                title:  this.hasError('email') ?
                (   
                    <div> 
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.EmailCol}
                            onChange={e => { 
                                this.handleOnChange('email', e);
                                console.log('build column email: ', this.state.EmailCol);
                            }}
                        >
                        {
                            this.props.columnHeaders.map((item, i) =>  
                                <option id={item.index} value={item.index} key={item.index}> 
                                    {item.name} 
                                </option> )
                        }
                        </Select>
                    </div>
                ) : 'Email',
                dataIndex: 'email',
                sorter: this.hasError('email') ? undefined : (a: any, b: any) => a.email.localeCompare(b.phone),
                className: 'rows',
                render: (text: any) => 
                text === INVALIDEMAILMSG ? (
                    <div
                        className="clipped"
                        title={strings.lsEmailErrorTxt}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : text === NODATAMSG ? (
                        
                    <div
                        title={strings.lsCSVUploadInfoTxt5}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : (
                    <div className="clipped" title={text}>
                        {text}
                    </div>),
                onHeaderCell: (column) => {
                    return column.sorter !== undefined ?
                    {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    } : null;
                }
            },
            {            
                title:  this.hasError('phone') ?
                (   
                    <div> 
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.PhoneCol}
                            onChange={e => { 
                                this.handleOnChange('phone', e);
                                console.log('build column phone: ', this.state.PhoneCol);
                            }}
                        >
                        {
                            this.props.columnHeaders.map((item, i) =>  
                                <option id={item.index} value={item.index} key={item.index}> 
                                    {item.name} 
                                </option> )
                        }
                        </Select>
                    </div>
                ) : 'Phone',
                dataIndex: 'phone',
                sorter: this.hasError('phone') ? undefined : (a: any, b: any) => a.phone.localeCompare(b.phone),
                className: 'rows',
                render: (text: any) => 
                text === INVALIDPHONEMSG ? (
                    <div
                        className="clipped"
                        title={strings.lsPhoneErrorTxt}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : text === NODATAMSG ? (
    
                    <div
                        title={strings.lsCSVUploadInfoTxt5}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : (
                    <div className="clipped" title={text}>
                        {text}
                    </div>),
                onHeaderCell: (column) => {
                    return column.sorter !== undefined ?
                    {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    } : null;
                }
            },
            {            
                title:  this.hasError('sport') ?
                (   
                    <div> 
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.SportCol}
                            onChange={e => { 
                                this.handleOnChange('sport', e);
                                console.log('build column sport: ', this.state.SportCol);
                            }}
                        >
                        {
                            this.props.columnHeaders.map((item, i) =>  
                                <option id={item.index} value={item.index} key={item.index}> 
                                    {item.name} 
                                </option> )
                        }
                        </Select>
                    </div>
                ) : 'Sport',
                dataIndex: 'sport',
                // sorter: this.hasError('sport') ? undefined : (a: any, b: any) => a.sport.localeCompare(b.sport),
                className: 'rows',
                render: (text: any) => 
                text === INVALIDSPORTMSG ? (
                    <div
                        className="clipped"
                        title={strings.lsSportDescTxt}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : (
                    <div className="clipped" title={text}>
                        {text}
                    </div>),
                onHeaderCell: (column) => {
                    return column.sorter !== undefined ?
                    {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    } : null;
                }
            },
            {            
                title:  this.hasError('level') ?
                (   
                    <div> 
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.LevelCol}
                            onChange={e => { 
                                this.handleOnChange('level', e);
                                console.log('build column level: ', this.state.LevelCol);
                            }}
                        >
                        {
                            this.props.columnHeaders.map((item, i) =>  
                                <option id={item.index} value={item.index} key={item.index}> 
                                    {item.name} 
                                </option> )
                        }
                        </Select>
                    </div>
                ) : 'Level',
                dataIndex: 'level',
                // sorter: this.hasError('sport') ? undefined : (a: any, b: any) => a.sport.localeCompare(b.sport),
                className: 'rows',
                render: (text: any) => 
                text === INVALIDLEVELMSG ? (
                    <div
                        className="clipped"
                        title={strings.lsLevelDescTxt}
                        style={{color: 'red'}}
                    >
                    {text}
                    </div>) : (
                    <div className="clipped" title={text}>
                        {text}
                    </div>),
                onHeaderCell: (column) => {
                    return column.sorter !== undefined ?
                    {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    } : null;
                }
            }
        );
    }
    
    private filterUpload(data: any) {
        
        let duplicateProfileCnt = 0;
        let filteredProfile: Array<any> = [];
        let profiles = this.props.currentProfiles;

        if (data.length) {            
            
            data.forEach( element => {
                
                let duplicates = profiles.filter(profile => {
                        let playerinfo = profile.playerinfo !== undefined ? profile.playerinfo.filter((e: any) => 
                                            e.playerinfoname === 'birthdate') : '';

                        let birthdate = playerinfo.length !== 0 &&  playerinfo[0].playerinfovalue !== null ? 
                                        playerinfo[0].playerinfovalue : '';

                        let uploadedDobInMs = this.getDateInMS(element.dob);

                        if (element.firstname.trim() === profile.firstname.trim()
                            && element.lastname.trim() === profile.lastname.trim()
                            && birthdate.trim() === uploadedDobInMs.trim()
                        ) {                            
                            element.playerid = profile.playerid;
                            return true;
                        }
                        return false;                
                });

                let indx = 0;
                if (duplicates != null && duplicates.length > 0) {
                    
                    duplicateProfileCnt += duplicates.length;                    
                    duplicates.forEach(duplicate => {
                        
                        let profileData = {
                            index: indx++,
                            playerid: duplicate.playerid,    
                            firstname: element.firstname,    
                            middlename: element.middlename,    
                            lastname: element.lastname,    
                            id: element.id,    
                            dob: element.dob,    
                            gender: element.gender,
                            sport: element.sport,
                            level: element.level,
                            email: element.email,
                            phone: element.phone,              
                            organization: element.organization
                        };

                        filteredProfile.push(profileData);
                    });
                } else {
                    filteredProfile.push(element);
                }
            });  
        }

        console.log('filteredProfile', filteredProfile);
        console.log('duplicateCount', duplicateProfileCnt);        
        return {profiles: filteredProfile, duplicateCount: duplicateProfileCnt};
    }

    /**
     * This function is called when Upload button is clicked.
     * Data is sent to server for uploading.
     */
    private async uploadProfiles() {

        this.setState({disableUpload: true, loading: true});
        console.log('column data', this.state.columnData);
        let uploadData = this.filterUpload(this.state.columnData);
        let profiles: any = this.getProfileObj(uploadData.profiles);
        console.log(JSON.stringify(profiles));       
        let blb: any = new Blob([JSON.stringify(profiles)], { type: 'text/plain' });
        console.log('bln created', blb);
        // let file = new File([blb], 'text.txt');
        let file = blb;

        // file.name = 'test.txt';
        console.log('file', file);
        let ser = new dataservice();
        console.log('this.props.match.params.rosterid', this.props.rosterid);
        let response = await ser.uploadFile(file, this.props.rosterid, this.props.rosterName).catch(err => {
                            this.setState({ disableUpload: false, loading: false });
                            message.error(
                            'Profiles could not be uploaded!! Please try again later');
                       });
         
        console.log('upload Profile response', response);        
        if ( response !== null && response !== undefined && 
            response.status !== undefined && response.status === 0 ) {
            this.props.handleNextClick(
                {uploads: uploadData.profiles.length - 
                    uploadData.duplicateCount, 
                updates: uploadData.duplicateCount}, 
                4);
        } else {
            this.setState({ disableUpload: false, loading: false });
            message.error(
                'Profiles could not be uploaded!! Please try again later');
        }
    }

    /**
     * Returns profile object in json format
     * to be sent to server for processing
     */
    private getProfileObj(data: any): any {
        let dob = '';     
        let profiles: any = [];
        data.forEach((e: any) => {
            if (e.dob !== '' && e.dob !== null  
                            && e.dob !== undefined) {
                dob = this.getDateInMS(e.dob);
            }
            let inputPlayer: any = {
                'playerid': e.playerid !== null ? e.playerid.trim() : '',
                'firstname': e.firstname !== null ? e.firstname.trim() : '',
                'lastname': e.lastname !== null ? e.lastname.trim() : '',
                'playerinfo': [{
                    'playerinfoname': 'gender',
                    'playerinfovalue': e.gender !== null ? e.gender : ''
                }, {
                    'playerinfoname': 'sport',
                    'playerinfovalue': e.sport !== null && e.sport !== undefined ? e.sport : ''
                }, {
                    'playerinfoname': 'level',
                    'playerinfovalue': e.level !== null && e.level !== undefined ? e.level : ''
                }, {
                    'playerinfoname': 'birthdate',
                    'playerinfovalue': dob
                }, {
                    'playerinfoname': 'profileID',
                    'playerinfovalue': e.id !== null ? e.id.trim() : ''
                }, {
                    'playerinfoname': 'middlename',
                    'playerinfovalue': e.middlename !== null ? e.middlename.trim() : ''
                }, {
                    'playerinfoname': 'email',
                    'playerinfovalue': e.email !== null ? e.email.trim() : ''
                }, {
                    'playerinfoname': 'phone',
                    'playerinfovalue': e.phone !== null ? e.phone.trim() : ''
                }]
                };  
            profiles.push(inputPlayer);
        });
        console.log('profiles', profiles);
        return profiles;
    }

    /**
     * Converts date to milliseconds i.e. returns the timestamp in UTC.
     * @param value date value
     */
    private getDateInMS(value: any) {
        if (value === '' && value === null  
                            && value === undefined) {
            return '';
        }

        let dateObj = new Date(value);
        let dateInMS = new Date(
                                dateObj.getFullYear(), 
                                dateObj.getMonth(), 
                                dateObj.getDate()).getTime().toString();   
        return dateInMS;    
    }

    private getVerifiedRowKey(key: any) {
        let selectedRow: any = this.state.columnData.filter(obj => { 
            return obj.index === key; });
        return selectedRow[0].status === 'verified';
    }

    private hasError(key: string) {
     
        let errorRows = this.props.columnData.filter((e: any) => { 
            
            let hasPhone = e['phone'.toString()] !== undefined && e['phone'.toString()] !== '';
            let hasEmail = e['email'.toString()] !== undefined && e['email'.toString()] !== '';
            if (!hasEmail && !hasPhone) {
                e['email'.toString()] = e['phone'.toString()] = NODATAMSG;
                return true;
            }
            if (e[key].toString().trim() === INVALIDSPORTMSG) {
                return true;
            }
            if (e[key].toString().trim() === INVALIDLEVELMSG) {
                return true;
            }

            if ( REQUIREDKEYS.indexOf(key) > -1 ) {
                    if (e[key]  === undefined || e[key]  === null ) {
                        return true;
                    } else if (e[key] !== undefined && e[key]  !== null && e[key].toString().trim() === '') {
                        if (!((key.toLowerCase() === 'phone' || key.toLowerCase() === 'email') 
                            && e[key].toString().trim() === '')) {
                            return true;
                        }
                    } else if (e[key].toString().trim() === ERRORMSG) {
                        return true;
                    } else if (e[key].toString().trim() === NODATAMSG) {
                        return true;
                    } else if (e[key].toString().trim() === INVALIDDATEFORMATMSG) {
                        return true;
                    } else if (e[key].toString().trim() === INVALIDGENDERMSG) {
                        return true;
                    } else if (e[key].toString().trim() === INVALIDEMAILMSG) {
                        return true;
                    } else if (e[key].toString().trim() === INVALIDPHONEMSG) {
                        return true;
                    } else if (e[key].toString().trim() === INVALIDPHONEMSG) {
                        return true;
                    }
                }
            return false;
        });
       
        if (errorRows !== null && errorRows.length > 0) {           
            return true;
        }

        return false;
    }

    private handleOnChange(column: string, index: any) {
        
        let stateData: any = { 
            GenderCol: this.state.GenderCol,  
            DOBCol: this.state.DOBCol, 
            FirstNameCol: this.state.FirstNameCol, 
            LastNameCol: this.state.LastNameCol,
            EmailCol: this.state.EmailCol,
            PhoneCol: this.state.PhoneCol
        };

        let colData = this.props.columnData; 
        
        this.state.columnData.map(row => {
            colData.map(ele => { 
            if (ele.index === row.index) {                 
                for (let key of Object.keys(row)) {
                    if (key === column) {
                        let csvIndx = this.props.hasHeader ? row.index : row.index - 1;
                        let csvData = this.props.csvRows[csvIndx];
                        let data = index !== -1 ? csvData[index] : '';
                        ele[key] = row[key] = data;
                        if (column === 'gender') {                        
                            ele[key] = row[key] = this.props.validateGender(data);
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.GenderCol && stateData.GenderCol !== col) {
                                stateData.GenderCol = col;
                                // this.setState({GenderCol : col});
                                console.log('selectedGenderCol: ', col); 
                            }
                        }
                        if (column === 'dob') {                        
                            ele[key] = row[key] = this.props.getDob(data);
                            let col = this.props.columnHeaders.filter(e =>  { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.DOBCol && stateData.DOBCol !== col) {
                                stateData.DOBCol = col;
                                console.log('selectedDOBCol: ', col);
                            }
                        }
                        if (column === 'firstname') {
                            ele[key] = row[key] = csvData[index] !== undefined && csvData[index] !== null
                            && csvData[index].toString().trim().length > 0 ? csvData[index] : NODATAMSG;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            
                            if (col !== this.state.FirstNameCol && stateData.FirstNameCol !== col) {
                                stateData.FirstNameCol = col;
                                console.log('selectedFirstNameCol: ', col);
                            }
                        }
                        if (column === 'lastname') {
                            ele[key] = row[key] = csvData[index] !== undefined && csvData[index] !== null
                            && csvData[index].toString().trim().length > 0 ? csvData[index] : NODATAMSG;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            
                            if (col !== this.state.LastNameCol  && stateData.FirstNameCol !== col) {
                                stateData.LastNameCol = col;
                                console.log('selectedLastNameCol: ', col);
                            }
                        }            
                        if (column === 'email') {                        
                            ele[key] = row[key] = data ? this.props.validateEmail(data) : 
                                data === undefined ? NODATAMSG : data;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.EmailCol && stateData.EmailCol !== col) {
                                stateData.EmailCol = col;
                                console.log('selectedEmailCol: ', col); 
                            }
                        }
                        if (column === 'phone') {                        
                            ele[key] = row[key] = data ? this.props.validatePhone(data) : 
                                data === undefined ? NODATAMSG : data;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.PhoneCol && stateData.PhoneCol !== col) {
                                stateData.PhoneCol = col;
                                console.log('selectedPhoneCol: ', col); 
                            }
                        }
                        if (column === 'sport') {   
                            console.log('column sport', data);                     
                            ele[key] = row[key] = data ? this.props.validateSport(data) : 
                                data === undefined ? NODATAMSG : data;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.SportCol && stateData.SportCol !== col) {
                                stateData.SportCol = col;
                                console.log('selectedSportCol: ', col); 
                            }
                        }    
                        if (column === 'level') {   
                            console.log('column level', data);                     
                            ele[key] = row[key] = data ? this.props.validateLevel(data) : 
                                data === undefined ? NODATAMSG : data;
                            let col = this.props.columnHeaders.filter(e => { 
                                return e.index === index; })[0].name;
                            if (col !== this.state.LevelCol && stateData.LevelCol !== col) {
                                stateData.LevelCol = col;
                                console.log('selectedLevelCol: ', col); 
                            }
                        }    
                    }
                }
            }
            
            });
        });

        this.setState(stateData, () => {
            console.log('handleOnChange callback: ', this.state);
            let errorRows = this.validateData(this.state.columnData);
            if (errorRows !== undefined && errorRows.length === 0) {
            
                let dups = this.checkDuplicateProfiles(colData);
                if (dups !== undefined && dups.length > 0) {
                    const duppagination = { ...this.state.pagination };
                    duppagination.total = dups.length;
                    duppagination.pageSize = 20 ;
                    duppagination.pageSizeOptions = ['20', '50', '75', '100'];
                    duppagination.showSizeChanger = true ;  
                    duppagination.showTotal = function (total: any) {
                        return `Total ${total} profiles`;
                    };  
                    this.setState({
                        isError: false,
                        hasDuplicate: true,
                        duplicateProfiles: dups,
                        columns: this.buildColumns(true),
                        columnData: colData,
                        pagination: duppagination
                    });
    
                    message.error('Please remove all ambiguities to proceed.');   
                    return;             
                } 
            }
            
            const pagination = { ...this.state.pagination };
            pagination.total = errorRows.length > 0 ? errorRows.length : colData.length;
            pagination.pageSize = 20 ;
            pagination.pageSizeOptions = ['20', '50', '75', '100'];
            pagination.showSizeChanger = true ;  
            pagination.showTotal = function (total: any) {
                return `Total ${total} profiles`;
            };             

            this.setState({
                columns: this.buildColumns(),                
                columnData: errorRows.length > 0 ? errorRows : colData,
                isError: errorRows.length > 0 ? true : false,
                pagination
            });
        });
        
        console.log('handleOnChange: ', this.state);
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/UploadProfileContentFour.tsx